export const columns = [
  {
    field: "name",
    headerName: "Name",
    minWidth: 200,
    required: true,
    editable: true,
    flex: 1,
  },
  {
    field: "disk_size",
    headerName: "Disk Size",
    minWidth: 200,
    required: true,
    editable: true,
    flex: 1,
  },
  {
    field: "disk_type",
    headerName: "Disk Type",
    minWidth: 200,
    editable: true,
    required: true,
    flex: 1,
  }
];

export class NewEntry {
  name = "";
}
